import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import Layout from "../../../components/common/Layout";
import StatusActive from "../../../components/constants/StatusActive";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import AlertContext from "../../../context/alert/alertContext";
import Alerts from "../../layout/Alerts";
import checkTime from "../../../components/constants/CheckTime"
import { addAuditLog } from "../../../components/AuditLog"

const Event = props => {
  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 7)[0];

  const exportExcel = () => {
    //add Audit Log
    addAuditLog({ menu: "Events" , event: "Export Events", createBy: userId });

    const result = [];
    result.push(eventColumns.filter( c => columnsCheckFormData[c.selector]).map( x => x.name));

    (eventData).forEach(item => {
      let row = [];
      (Object.keys(columnsCheckFormData).filter(k => columnsCheckFormData[k])).forEach(key => {
        if(key === 'Image'){
          row.push(item['FilePath']);
        } else if(key === 'StatusActive'){
          row.push(item[key] ? 'Active' : 'InActive');
        } else if(key === 'HasDeadLine'){
          row.push(item[key] ? 'has deadline' : 'no deadline');
        } else {
          row.push(item[key]);
        }
      });
      result.push(row);
    });

    const cols = eventColumns.filter(c => columnsCheckFormData[c.selector]).map(x => x.name);
    const queryString = JSON.stringify(eventFormData);

    console.log(JSON.stringify(cols));
    console.log(JSON.stringify(eventFormData));

    //console.log(result);
    axios.get(process.env.REACT_APP_API_URL + "/api/exportexcelevents/", {
      responseType: 'blob',
      //params: {data : result}
      params: {col : `${JSON.stringify(cols)}`, eventFormData : `${queryString}` }

     }).then(response => {
        let link = document.createElement('a');
        let day = new Date();
     
        link.href = window.URL.createObjectURL(new Blob([response.data], 
          {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
        link.download = day.toISOString().slice(0,10) + "-Event_export.xlsx";
        link.click();
     }).catch(error => {
        console.log(error)
     })
  }

  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const [showEditModal, setShowEditModal] = useState({
    show: "",
    showPop: false,
    eventId: ""
  });
  const [showDeleteEvent, setShowDeleteEvent] = useState({
    eventId: "",
    showPop: false
  });
  const [showConfirmEvent, setShowConfirmEvent] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user")) === null ? null : JSON.parse(localStorage.getItem("user"))[0].Id;
  const [eventFormModalDefault, setEventFormModalDefault] = useState({
    eventsName: "",
    hasDeadLine: 0,
    createBy: userId,
    mapCaseType : []
  });
  const [eventFormModal, setEventFormModal] = useState(eventFormModalDefault);
  const [eventFormData, setEventFormData] = useState({ eventsName: "" });
  const [eventData, setEventData] = useState([]);
  const eventColumns = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary ml-2"
            type="button"
            onClick={() => {
              setShowEditModal({
                show: "Edit",
                showPop: true,
                eventId: row.EventsId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          <button
            hidden={!pagePermission.IsDelete}
            className={"btn btn-sm btn-" + ( row.cantDelete ? "secondary" : "danger") + " ml-2"}
            disabled={row.cantDelete}
            type="button"
            onClick={() => {
              setShowDeleteEvent({ eventId: row.EventsId, showPop: true });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: "180px",
      button: true,
      show: pagePermission.IsUpdate|| pagePermission.IsDelete ? 1:0
    },
    {
      name: "Event Name",
      selector: "EventsName",
      sortable: true,
      wrap: true
    },
    {
      name: "Has Deadline",
      cell: row => (
        <div>
          { !row.HasDeadLine && (
            <h6>
              <span className="badge badge-secondary"><i className="fa fa-times" /></span>
            </h6>
          )}
          { row.HasDeadLine && (
            <h6>
              <span className="badge badge-primary"><i className="fa fa-check" /></span>
            </h6>
          )}
        </div>
      ),
      selector: "HasDeadLine",
      sortable: true,
      wrap: true,
      center: true
    },
    {
      name: "Status",
      selector: "StatusActive",
      sortable: true,
      center: true,
      cell: row => (
        <div>
          {StatusActive.InActive === row.StatusActive && (
            <h6>
              <span className="badge badge-danger text-left">InActive</span>
            </h6>
          )}
          {StatusActive.Active === row.StatusActive && (
            <h6>
              <span className="badge badge-success text-left">Active</span>
            </h6>
          )}
        </div>
      )
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    },
    {
      name: "CreateBy",
      selector: "CreateBy",
      sortable: true,
      wrap: true
    },
    {
      name: "CreateDateTime",
      selector: "CreateDateTime",
      sortable: true,
      wrap: true
    }
  ];
  const [showManageColumns, setShowManageColumns] = useState(false);
  const [listColumnsShow, setListColumnsShow] = useState([]);
  const [columnsCheckFormData, setcolumnsCheckFormdata] = useState({
    EventsName: 1,
    HasDeadLine: 1,
    StatusActive: 1,
    LastUpdateBy: 1,
    LastUpdateDateTime: 1,
    CreateBy: 0,
    CreateDateTime: 0
  });
  const [caseType, setCaseType] = useState([]);
  const reloadEvent = async () => {
    await axios.get(process.env.REACT_APP_API_URL + "/api/events").then(res => {
      setEventData(res.data);
    });
    setEventFormData({ eventsName: "" });
  };
  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime(); });
    reloadEvent();
    //load case type list
    axios.get(process.env.REACT_APP_API_URL + "/api/casetype/ddl").then(res => {
      setCaseType(res.data);
      setEventFormModalDefault({ ...eventFormModalDefault, mapCaseType: res.data.map((e) => e.value)});
    });
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    setListColumnsShow(Object.keys(columnsCheckFormData).reduce((ret, curr) => 
    columnsCheckFormData[curr] ? [...ret, curr] : ret
    , []));
  },[columnsCheckFormData])
  useEffect(() => {
    if (showEditModal.eventId === "" || showEditModal.show === "Add" ) {
      setEventFormModal(eventFormModalDefault);
    } else {
      axios
        .get(
          process.env.REACT_APP_API_URL + "/api/events/" + showEditModal.eventId
        )
        .then(res => {
          setEventFormModal({
            ...eventFormModal,
            eventsName: res.data[0].EventsName,
            hasDeadLine: res.data[0].HasDeadLine,
            mapCaseType: res.data[0].TypeMap.split(',').map((e) => parseInt(e))
          });
        });
    }
    //eslint-disable-next-line
  }, [showEditModal]);
  // useEffect(() => {
  //   console.log(eventFormModal)
  // })

  const saveAdd = () => {
    if (showEditModal.show === "Add") {
      axios
        .post(process.env.REACT_APP_API_URL + "/api/events", eventFormModal)
        .then(res => { submitSave(res); });
    } else if (showEditModal.show === "Edit") {
      axios
        .put(
          process.env.REACT_APP_API_URL +
            "/api/events/" +
            showEditModal.eventId,
          eventFormModal
        )
        .then(res => { submitSave(res); });
    }

    const submitSave = (res) => {
      setShowConfirmEvent(false);
      if (res.data.status === "0"){
        setShowEditModal({ show: "", showPop: false, eventId: "" });
        setAlert(res.data.msg, "success");
        reloadEvent();
      } else {
        setAlert(res.data.msg, "danger");
      }
    }
  };
  const onChangeCheckColumns = (e) => {
    setcolumnsCheckFormdata({ 
      ...columnsCheckFormData, [e.target.name] : !columnsCheckFormData[e.target.name]
    })
  }
  const checkInputManageColumn = (name) => 
    (<div key={name} className="col-sm-12">
        <input 
          type="checkbox" 
          className="checkboxCustom1"
          id={name}
          name={name} 
          defaultChecked={columnsCheckFormData[name]} 
          onChange={onChangeCheckColumns} /> 
          <label htmlFor={name}>
            {eventColumns.filter( c => c.selector === name)[0].name}
          </label>
      </div>)
  const color = ['#75acc9', '#00667b', '#063244', '#0d2a3b', '#84415e', '#aa536c', '#e8697a', '#f27d81', '#ecb891'];
  const checkCaseType = (id, name) =>
    (
      <div key={id} className="col-md-6">
        <div className="btn-group" 
          onClick={() => {
            var mapCaseTypeValue = eventFormModal.mapCaseType;
            var indexId = mapCaseTypeValue.indexOf(id);
            if(indexId === -1){
              mapCaseTypeValue.push(id);
              mapCaseTypeValue.sort();
            } else {
              mapCaseTypeValue.splice(indexId, 1);
            }
            setEventFormModal({ ...eventFormModal, mapCaseType: mapCaseTypeValue});
          }}
          >
            <label className="btn" style={{backgroundColor:color[id]||color[0], borderColor:color[id]||color[0], color:'#fff', width:"40px"}}>
              <span className="glyphicon glyphicon-ok">
              { eventFormModal.mapCaseType.indexOf(id) !== -1 ? '✔' : ' ' }
              </span>
            </label>
            <label className="cbAAA btn btn-default active"> {name}</label>
        </div>
      </div>
    )

  return (
    <Layout activeLinkTo="/events" menuId="7">
      <div className="container-fluid" style={{ minHeight: 500 }}>
      <Alerts />
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Event</h5>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <label className="title control-label">Event Name</label>
                <input
                  type="search"
                  className="form-control"
                  value={eventFormData.eventsName}
                  onChange={e =>
                    setEventFormData({
                      ...eventFormData,
                      eventsName: e.target.value
                    })
                  }
                />
              </div>
            </div>

            <div className="row mt-2 float-right">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    axios
                      .get(process.env.REACT_APP_API_URL + "/api/events", {
                        params: eventFormData
                      })
                      .then(res => {
                        setEventData(res.data);
                      });
                  }}
                >
                  <i className="fa fa-search"></i> Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        
        {/*table Data */}
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Data</h5>
          <div className="card-body">
            <div className="table-responsive" style={{padding:"10px 0"}}>
              <button
                hidden={!pagePermission.IsCreate}
                type="button"
                className="btn btn-success"
                onClick={() => {
                  setShowEditModal({
                    show: "Add",
                    showPop: true,
                    eventId: ""
                  });
                }}
              >
                <i className="fa fa-plus"></i> Add
              </button>
              <button type="button" className="btn btn-primary ml-2" onClick={() => {setShowManageColumns(true)}}>
                <i className="fa fa-cog"></i> Manage Columns
              </button>
              <button type="button" className="btn btn-primary mr-2" 
                style={{position:"absolute", right:0}} 
                onClick={() => exportExcel()} >
                <i className="fa fa-external-link"></i> Export file
              </button>
              <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
              </a>
              <DataTable
                noHeader={true}
                pagination={true}
                paginationPerPage={50}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                columns={eventColumns.filter(columns => listColumnsShow.includes(columns.selector)||columns.show === 1 )}
                data={eventData}
              />
              <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Modal Add/Edit Events */}
      <Modal
        show={showEditModal.showPop}
        onHide={() => {
          setShowEditModal({ show: "", showPop: false, eventId: "" });
        }}
        centered
      >
        <Modal.Header closeButton>
          {showEditModal.show === "Add" && <Modal.Title>Add Event</Modal.Title>}
          {showEditModal.show === "Edit" && (
            <Modal.Title>Edit Event</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight">
            <Alerts />
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Event Name<span style={{ color: "red" }}> * </span>:
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="eventsName"
                  value={eventFormModal.eventsName}
                  onChange={e => {
                    setEventFormModal({
                      ...eventFormModal,
                      eventsName: e.target.value
                    });
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">
              <div className="col-md-3"></div>
              <div className="col-md-9">
                <label className="switch">
                  <input 
                    type="checkbox" 
                    checked={eventFormModal.hasDeadLine}
                    onChange={() => setEventFormModal({ ...eventFormModal, hasDeadLine: !eventFormModal.hasDeadLine}) } 
                  />
                  <span className="slider round"></span>
                </label>
                <span 
                  style={eventFormModal.hasDeadLine ? {} : {color: "darkgray"}}
                > {eventFormModal.hasDeadLine ? 'has deadline' : 'no deadline'} </span>
              </div>
            </div>
            <div className="row" style={{marginLeft:"24px"}}>
              {caseType.map( (e) => checkCaseType(e.value, e.label))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowEditModal({ show: "", showPop: false, eventId: "" });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={() => {
              if (eventFormModal.eventsName === "") {
                setAlert("event name is null! Plese fill", "warning");
              } else {
                setShowConfirmEvent(true);
              }
            }}
          >
            {showEditModal.show === "Add" && (
              <i className="fa fa-plus"> Add </i>
            )}
            {showEditModal.show === "Edit" && (
              <i className="fa fa-floppy-o"> Save</i>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Add/Edit Events */}

      {/* Modal Delete events */}
      <Modal
        show={showDeleteEvent.showPop}
        onHide={() => {
          setShowDeleteEvent({ eventId: "", showPop: false });
        }}
        centered
      >
        <Modal.Header closeButton>
          <div
            style={{
              width: 39,
              height: 39,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative"
            }}
          >
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title style={{ paddingLeft: 13 }}>
            Delete Event
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please make sure Once deleted, items cannot be returned.</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDeleteEvent({ eventId: "", showPop: false });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              axios
                .put(
                  process.env.REACT_APP_API_URL +
                    "/api/events/delete/" +
                    showDeleteEvent.eventId,
                  {
                    createBy: userId
                  }
                )
                .then(res => {
                  setShowDeleteEvent({ eventId: "", showPop: false });
                  setAlert(res.data.msg, "danger");
                  reloadEvent();
                });
            }}
          >
           <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Delete events */}

      {/* Madal confirm Add/Edit Events */}
      <Modal
        show={showConfirmEvent}
        onHide={() => {
          setShowConfirmEvent(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowConfirmEvent(false);
            }}
          >
          <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={saveAdd}
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Madal confirm Add/Edit Events */}

      {/* Modal Manage Columns*/}
      <Modal
        size="sm"
        dialogClassName="columnsManageCustom"
        show={showManageColumns}
        onHide={() => {
          setShowManageColumns(false);
        }}
        centered
      >
        <Modal.Header closeButton className="replaceCloseBtn">
          <Modal.Title><i className="fa fa-columns" /> Manage Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {Object.keys(columnsCheckFormData).map( (e) => checkInputManageColumn(e))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal Manage columns*/}
    </Layout>
  );
};

export default Event;
